import { createSlice } from '@reduxjs/toolkit'
// import utils from '../../utils/utils';

const initialState = {
    status: false, // 是否获取公共数据
    message: '', // 接口提示
    publicInit: {}, // 公共数据
    resNum: 0,
    error: {}, // 请求状态
    pageInit: {
        recommended: {}, // 中台页面缓存
        SEOChecker: {}, // SEO Checker
        GoogleAnalytics: null, // 谷歌分析登录
        MetaTags: null, // 元标签元描述页面缓存
        ExchangeBacklink: {}, //外链互换
        onPage: {}, // onpage页面缓存 
        htmlSitemap: {
            isResetLoading: false, // 页面btn-loading
            getStructuredData: {}
        }, // html站点地图页面缓存
        speedAnalysis: {}, // speed页面缓存
        jsonLD: {}, // jsonLD页面缓存
        integration: {
            isResetLoading: false, // 页面btn-loading
            getShopifyPrimary: {}
        }, // 功能集合页面缓存
        pricingPlan: null, // 价格页面缓存
    },
    window_width: window.innerWidth,
    window_scrollY: 0,
    tinymce_info: false, // 富文本加载状态
    shopOwner: '', // 店铺用户名称
    domain: '', // 店铺域名
    email: '', // 店铺邮箱
    topId: 0, // 默认首页0
    topSonId: 0, // 默认0第一个
    Language: '', // 默认空
    payTipStatus: 0, // 支付提示信息
    ActMealData: {}, // 改版活动数据
    InstantPageSwitch: -1, // instant状态
    level: 1, // 默认1
    imageOptAuto: false, // 图片压缩 自动开关状态
    imageAltAuto: false, // 图片Alt 自动开关状态
    uid: -1, // 用户id
    isShowTopMenu: true, // 测试对象状态
    AllAdverData: {},   // 广告配置数据
    isComboUser: false,     // 是否组合套餐用户
    isHiddenScroll: false,     // 是否操作了滚动条
    shopDomain: '',         // shopify 域名
    shopifyLangState: false,    // 是否已设置shopify语言
    appLangState: false,        // 是否已设置app语言
    OnpageListParams: {
        state: 1,
        params: {},
    },       // onpage列表参数
    windowData: null,
}

export const publicData = createSlice({
    name: 'public',
    initialState,
    reducers: {
        // 线上调用shopify app接口的数据，直接设置全局状态
        //   设置公共数据
        setPublicData: (state, action) => {
            state.publicInit = action.payload.data;
            if (action.payload.ack === 1) {
                const _that = action.payload.data.shop_data;  // 用户数据
                const uid = _that.id;   // 用户id
                state.status = true; // 拿到数据设置为true
                state.uid = uid;
                state.shopOwner = _that.shop_owner;
                state.domain = _that.domain;
                state.shopDomain = _that.name;
                state.email = _that.email;
                state.level = _that.level;
                state.isComboUser = action.payload.data.head_data?.is_combo_plan;
                // 判断是否内嵌模式
                // const params = new URLSearchParams(window.location.search);
                // const shop = params.get("shop");
                // const host = params.get("host");
                // 判断是否兼容shopify语言
                let spf_Lang = _that.language;
                if (!window.shopify) {
                    state.Language = spf_Lang;
                    window.Language = spf_Lang;
                }

                // 前端监控
                if (window.__bl && window.__bl.setConfig) {
                    window.__bl.setConfig({
                        setUsername: function () {
                            return _that.domain;
                        },
                        uid: _that.domain,
                        domain: window.location.hostname
                    });
                }

                // Hotjar
                if (window.hj) {
                    const userId = uid || null;
                    window.hj('identify', userId, {// Add your own custom attributes here. Some EXAMPLES:
                        name: _that.name,
                        domain: _that.domain,
                        level: _that.level,
                        Shopify_Merchant_type: _that.plan_display_name,
                    });
                }
                // 关闭启动动画 
                // eslint-disable-next-line no-unused-expressions
                window?.hideLoadingState();

                try {
                    // cio 埋点
                    const CompLang = {
                        "cs": "cs",
                        "da": "da",
                        "ge": "de",
                        "en": "en",
                        "sp": "es",
                        "fr": "fr",
                        "it": "it",
                        "in": "in",
                        "dut": "nl",
                        "nb": "nb",
                        "pl": "pl",
                        "pt_BR": "pt-BR",
                        "pt": "pt-PT",
                        "fi": "fi",
                        "sv": "sv",
                        "tr": "tr",
                        "th": "th",
                        "ja": "ja",
                        "zh": "zh-CN",
                        "zh_hant": "zh-TW",
                        "ko": "ko",
                    }
                    // let creatAt = utils.timeFormat(_that?.created_at || 0);
                    if (window.shopify && _that.name && !Boolean(window.cio?.initialized)) {
                        window.cio?.init({
                            id: _that.name,
                            shop_owner: _that.shop_owner,
                            email: _that.email,
                            shop_name: _that.shopname,
                            shop_domain: _that.name,
                            shop_plan: _that.plan_display_name,
                            app_name: 'Seoant',                             // 应用名称，详见下方说明
                            language: CompLang[_that.language] || 'en',     // 语言简码
                            shopify_plan: _that.plan_display_name,          // Shopify套餐
                            country_name: _that.country,
                            city: _that.city,                               // 可选
                        })
                    }
                    // shop_plan: _that.level === 3 ? 'Pre Plan' : _that.level === 3 ? 'Pro Plan' : 'Free',
                    // shop_created_at: creatAt, // 可选
                } catch { }
            }
            state.msg = action.payload.msg;
        },

        // 设置广告数据
        setAllAdverData: (state, action) => {
            state.AllAdverData = action.payload;
        },

        // 改变语言状态
        changeLanguageInfo: (state, action) => {
            state.Language = action.payload;
            // 是否更新接口的数据
            const _shopData = state.publicInit?.shop_data;
            if (_shopData) {
                _shopData.language = action.payload;
            }
        },

        // 修改活动banner/轮播图状态
        changeActShowStatus: (state, action) => {
            state.publicInit.campaign_data.campaign_modal.top_status = action.payload[0];
            state.publicInit.campaign_data.campaign_modal.middle_status = action.payload[1];
        },

        // 设置宽度
        setWindowWidth: (state, action) => {
            state.window_width = action.payload;
        },

        // 设置滚动高度
        setWindowScrollY: (state, action) => {
            state.window_scrollY = action.payload;
        },

        //修改富文本加载状态
        setTinymceStatus: (state, action) => {
            state.tinymce_info = action.payload;
        },

        // 设置初始状态
        setAppPublicInit: (state) => {
            state.resNum = 1;
        },

        // 设置请求状态
        setRequestStatus: (state, action) => {
            state.error = action.payload;
            state.status = false; // 拿到数据设置为true
        },

        // 设置新手引导状态
        setGuideModalStatus: (state) => {
            state.publicInit.other_options.new_hand_guide = false;
        },

        // 设置导航栏tabsid
        changeTabsSelectedId: (state, action) => {
            state.topId = action.payload[0];
            state.topSonId = action.payload[1];
        },

        // 设置支付提示状态
        setPayTipStatus: (state, action) => {
            state.payTipStatus = action.payload;
        },

        // 设置改版活动
        setActMealResData: (state, action) => {
            state.ActMealData = action.payload;
        },

        // 设置更新首页分数
        setSeoPageScoreData: (state, action) => {
            state.publicInit.seo_data = action.payload;
        },

        // 设置评价状态
        saveStartReview: (state) => {
            state.publicInit.head_data.review_tips = false;
        },

        // 设置支付回调提示状态
        savePayTip: (state) => {
            state.publicInit.other_options.paid_confirm = 0;
        },

        // 设置instant page开关状态
        setStorePageStatus: (state, action) => {
            state.InstantPageSwitch = action.payload;
        },

        // 设置自定义缓存
        setSaveSwitchData: (state, action) => {
            state.publicInit.head_data.switch_data = action.payload;
        },

        // 设置图片压缩自动开关状态
        setImageAutoSwitchData: (state, action) => {
            state[action.payload.type] = action.payload.value;
        },

        // 设置顶部和导航栏状态
        setTopMenuState: (state, action) => {
            state.isShowTopMenu = action.payload;
        },

        // 是否设置了滚动条样式
        setScrollHiddenState: (state, action) => {
            state.isHiddenScroll = action.payload;
        },

        // 设置shopify语言
        setShopifyLang: (state, action) => {
            state.Language = action.payload;
            state.shopifyLangState = true;
        },

        // 设置app语言状态
        setLangState: (state, action) => {
            state.appLangState = action.payload;
        },

        // 缓存onpage列表参数
        setOnpageListParams: (state, action) => {
            state.OnpageListParams.state = 1;
            state.OnpageListParams.params = action.payload;
        },

        // 设置参数使用状态
        setOnpageListParamsReset: (state) => {
            state.OnpageListParams.state = 0;
        },

        // 缓存窗口通信数据
        setWindowSendData: (state, action) => {
            state.windowData = action.payload;
        }

    },
})

// Action creators are generated for each case reducer function
// 为每个case reducer函数生成动作创建者
export const {
    setPublicData,
    setAllAdverData,
    changeLanguageInfo,
    changeActShowStatus,
    setWindowWidth,
    setWindowScrollY,
    setTinymceStatus,
    setAppPublicInit,
    setRequestStatus,
    setGuideModalStatus,
    changeTabsSelectedId,
    setPayTipStatus,
    setSeoPageScoreData,
    setActMealResData,
    saveStartReview,
    savePayTip,
    setStorePageStatus,
    setSaveSwitchData,
    setImageAutoSwitchData,
    setTopMenuState,
    setScrollHiddenState,
    setShopifyLang,
    setLangState,
    setOnpageListParams,
    setOnpageListParamsReset,
    setWindowSendData,

} = publicData.actions

// selector 函数允许我们从 state 中获取值
// Selectors 也可以在使用的地方内联的方式定义
// 而不是仅仅只能在 slice 文件中。例如 : `useSelector((state) => state.counter.value)`
export const selectPublicData = state => state.public

export default publicData.reducer